import * as Api from "@/types/graphql";

export function getAreaGroups(area: Api.CodeDecode): Api.CodeDecodeChild[]{
    return area['code_decode_child']
}